module.exports = __webpack_public_path__ + "img/ts3_manager_logo.04ce97d0.svg";